import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EstimativaCronogramaKey } from 'src/app/models/estimativa-cronograma-key.model';
import { Misc } from '../../util/misc';
import { EstimativaCronogramaKeyService } from 'src/app/services/estimativa-cronograma-keys.service';

@Component({
  selector: 'app-adicionar-cronograma-key-dialog',
  templateUrl: './adicionar-cronograma-key-dialog.component.html',
  styleUrls: ['./adicionar-cronograma-key-dialog.component.scss']
})
export class AdicionarCronogramaKeyDialogComponent implements OnInit {

  basicForm: UntypedFormGroup;
  loading: boolean;
  filtroParametrosProjeto: Array<EstimativaCronogramaKey> = [];

  constructor(
    public dialogRef: MatDialogRef<AdicionarCronogramaKeyDialogComponent>,
    private estimativaCronogramaKeyService: EstimativaCronogramaKeyService,
    private fb: UntypedFormBuilder,
    public misc: Misc,
    @Inject(MAT_DIALOG_DATA) public data: EstimativaCronogramaKey
  ) {
    this.createForm();
  }

  ngOnInit() {
  }

  createForm() {
    this.basicForm = this.fb.group({
      estimativaCronogramaId: [null, Validators.required],
      descricao: [''],
      nomeParametroPlaneja: [''],
      idParametroPlaneja: 0
    });

    this.carregaDropDownParametrosPlaneja();
  }

  carregaDropDownParametrosPlaneja() {
    this.adicionarItemsFiltroCronogramaKey();
    this.filtroParametrosProjeto.sort((a, b) => (a.nomeParametroPlaneja.trim().toLowerCase() < b.nomeParametroPlaneja.trim().toLowerCase() ? -1 : 1));
  }

  adicionarItemsFiltroCronogramaKey() {
    let estimativaCronogramaKey = new EstimativaCronogramaKey;
    estimativaCronogramaKey.nomeParametroPlaneja = "InicioPlaneja";
    estimativaCronogramaKey.descricao = "Kick-off e Planejamento";
    estimativaCronogramaKey.estimativaCronogramaId = this.data?.estimativaCronogramaId;
    this.filtroParametrosProjeto.push(estimativaCronogramaKey);

    let estimativaCronogramaKey1 = new EstimativaCronogramaKey;
    estimativaCronogramaKey1.nomeParametroPlaneja = "EspecFunc";
    estimativaCronogramaKey1.descricao = "Us e Espec. Funcional";
    estimativaCronogramaKey1.estimativaCronogramaId = this.data?.estimativaCronogramaId;
    this.filtroParametrosProjeto.push(estimativaCronogramaKey1);

    let estimativaCronogramaKey2 = new EstimativaCronogramaKey;
    estimativaCronogramaKey2.nomeParametroPlaneja = "EspecTecnica";
    estimativaCronogramaKey2.descricao = "Espec. Técnica";
    estimativaCronogramaKey2.estimativaCronogramaId = this.data?.estimativaCronogramaId;
    this.filtroParametrosProjeto.push(estimativaCronogramaKey2);

    let estimativaCronogramaKey3 = new EstimativaCronogramaKey;
    estimativaCronogramaKey3.nomeParametroPlaneja = "ConstruTeste";
    estimativaCronogramaKey3.descricao = "Desenvolvimento";
    estimativaCronogramaKey3.estimativaCronogramaId = this.data?.estimativaCronogramaId;
    this.filtroParametrosProjeto.push(estimativaCronogramaKey3);

    let estimativaCronogramaKey4 = new EstimativaCronogramaKey;
    estimativaCronogramaKey4.nomeParametroPlaneja = "TesteIntegra";
    estimativaCronogramaKey4.descricao = "Testes Integrados";
    estimativaCronogramaKey4.estimativaCronogramaId = this.data?.estimativaCronogramaId;
    this.filtroParametrosProjeto.push(estimativaCronogramaKey4);

    let estimativaCronogramaKey5 = new EstimativaCronogramaKey;
    estimativaCronogramaKey5.nomeParametroPlaneja = "HomologaCerti";
    estimativaCronogramaKey5.descricao = "Homologação";
    estimativaCronogramaKey5.estimativaCronogramaId = this.data?.estimativaCronogramaId;
    this.filtroParametrosProjeto.push(estimativaCronogramaKey5);

    let estimativaCronogramaKey6 = new EstimativaCronogramaKey;
    estimativaCronogramaKey6.nomeParametroPlaneja = "Implanta";
    estimativaCronogramaKey6.descricao = "Implantação";
    estimativaCronogramaKey6.estimativaCronogramaId = this.data?.estimativaCronogramaId;
    this.filtroParametrosProjeto.push(estimativaCronogramaKey6);

    let estimativaCronogramaKey7 = new EstimativaCronogramaKey;
    estimativaCronogramaKey7.nomeParametroPlaneja = "PosImplanta";
    estimativaCronogramaKey7.descricao = "Pós-Implantação";
    estimativaCronogramaKey7.estimativaCronogramaId = this.data?.estimativaCronogramaId;
    this.filtroParametrosProjeto.push(estimativaCronogramaKey7);
  }

  close(): void {
    this.dialogRef.close();
  }

  save() {
    const cronogramaKeyForm: EstimativaCronogramaKey = this.basicForm.value;

    let cronogramaKey = new EstimativaCronogramaKey();
    cronogramaKey.estimativaCronogramaId = cronogramaKeyForm.estimativaCronogramaId;
    cronogramaKey.descricao = cronogramaKeyForm.descricao;
    cronogramaKey.nomeParametroPlaneja = cronogramaKeyForm.nomeParametroPlaneja;

    this.estimativaCronogramaKeyService.create(cronogramaKey).subscribe({
      next: () => {
        this.misc.mensagemSucesso("Key adicionada com sucesso no cronograma");
        this.close();
      },
      error: error => {
        this.misc.processError(error, "Ocorreu um erro ao adicionar Key no cronograma");
        this.loading = false;
      }
    });
  }

  setParametrosPlaneja(value) {
    this.basicForm = this.fb.group({
      estimativaCronogramaId: [value.estimativaCronogramaId],
      descricao: [value.descricao],
      nomeParametroPlaneja: [value.nomeParametroPlaneja],
    });
  }
}